export const MAX_NAVIGATION_WIDTH = '12.75rem';
export const MIN_NAVIGATION_WIDTH = '5rem';
export const MOBILE_TOOLBAR_HEIGHT = '4rem';
